import React, {CSSProperties, FC, useEffect, useRef} from 'react';

const canvasStyle: CSSProperties = {
  position: 'absolute',
  bottom: 50,
  right: 10,
  background: '#2d2d2d',
  border: '1px solid #bbbbbb'
};

type ArrayChartProps = {
  data: Array<number>,
  i: number,
  interpolateColor: (value: number) => [number, number, number]
}

const ArrayChart: FC<ArrayChartProps> = ({data, i, interpolateColor}) => {
  const ref = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = ref.current;
    if (canvas) {
      drawChart(canvas, data, i, interpolateColor);
    }
  }, [data, i, interpolateColor]);

  const drawChart = (canvas: HTMLCanvasElement, data: Array<number>, i: number, interpolateColor: (value: number) => [number, number, number]) => {
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const width = canvas.width;
    const height = canvas.height;
    const padding = 14;

    const yMin = 12;
    const yMax = 24;

    const stepX = (width - 2 * padding) / (data.length - 1);

    // CLEAR CHART
    ctx.clearRect(0, 0, width, height);

    // DRAW AXES
    ctx.strokeStyle = '#bbbbbb44';
    ctx.lineWidth = 1;
    ctx.beginPath();

    // Y axis labels
    ctx.fillStyle = '#bbbbbb';
    ctx.font = '10px sans-serif';
    ctx.textAlign = 'left';
    for (let i = yMin; i <= yMax; i++) {
      const y = height - padding - ((i - yMin) / (yMax - yMin)) * (height - 2 * padding);
      ctx.fillText(i.toString(), 2, y + 4);
      ctx.beginPath();
      ctx.moveTo(padding, y);
      ctx.lineTo(width - padding, y);
      ctx.stroke();
    }

    // Current time vertical line
    ctx.beginPath();
    ctx.moveTo(padding + i * stepX, padding);
    ctx.lineTo(padding + i * stepX, height - padding);
    ctx.stroke();

    // Elapsed time label
    ctx.font = '17px sans-serif';
    ctx.textAlign = 'right';
    ctx.fillText(`${i + 1982}`, width - padding, height - padding - 2);

    // DRAW DATA
    for (let i = 1; i < data.length; i++) {
      const prev = data[i - 1];
      const curr = data[i];

      if (isNaN(prev) || isNaN(curr)) continue; // Skip invalid segments

      const x1 = padding + (i - 1) * stepX;
      const y1 = height - padding - ((prev - yMin) / (yMax - yMin)) * (height - 2 * padding);

      const x2 = padding + i * stepX;
      const y2 = height - padding - ((curr - yMin) / (yMax - yMin)) * (height - 2 * padding);

      ctx.strokeStyle = `rgb(${interpolateColor((prev+curr)/2).join(' ')})`;
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y2);
      ctx.stroke();
    }
  };

  return <canvas ref={ref} id="chart" width="300" height="150" style={canvasStyle}></canvas>;
};

export default ArrayChart;
